import React from 'react';

import { PageContentContainer } from '@/components/layout/PageContentContainer';

import styles from './UnexpectedErrorPage.module.scss';

export const UnexpectedErrorPage = () => (
  <PageContentContainer breadcrumbs={[{ title: 'Something went wrong', current: true }]}>
    <div className={styles.title}>
      <p>We have encountered an error.</p>
      <p>
        Our developers have been notified and are looking into the problem. Thank you for your
        patience.
      </p>
    </div>
  </PageContentContainer>
);
